import { QueryObserverResult, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { API_QUERY_KEYS, QueryDefaults } from 'api';
import { GetExceptionLogsRequest, GetExceptionLogsResponse } from '../fragments';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { getExceptionLogs } from '../methods/getExceptionLogs';

import { exceptionLogsRequestState, exceptionLogsPageNumberState } from 'store';

export const useExceptionLogs = (
  options?: UseQueryOptions<GetExceptionLogsResponse>
): QueryObserverResult<GetExceptionLogsResponse> => {
  const setPageNumberState = useSetRecoilState(exceptionLogsPageNumberState);
  const stateValue = useRecoilValue(exceptionLogsRequestState);
  const request = { ...stateValue } as unknown as GetExceptionLogsRequest;

  return useQuery<GetExceptionLogsResponse>(
    [API_QUERY_KEYS.getExceptionLogs, request],
    () => getExceptionLogs(request),
    {
      ...QueryDefaults,
      ...options,
      onSuccess: (data: GetExceptionLogsResponse) => {
        if (data?.paginationInfo?.totalCount > 0 && data?.exceptions.items.length === 0) {
          setPageNumberState(1);
        }
      },
      onError: (err: unknown) => ({
        err,
      }),
    }
  );
};
